<template>
  <div class="xl:container xl:mx-auto flex w-full flex flex-around">
    <Toast position="top-center" />
    <ConfirmDialog></ConfirmDialog>
    <nav
      class="w-72 h-screen max-h-screen bg-fh-blue absolute sticky top-0 flex-shrink-0 overflow-auto"
    >
      <div class="w-full text-center py-6">
        <p class="text-white font-medium text-2xl">Foody Home</p>
      </div>
      <ul v-if="$page.props.current_admin.level >= 20">
        <li class="title">使用者管理</li>
        <ul>
          <li><Link :href="route('admin.users')">客戶總覽</Link></li>
          <li><Link :href="route('admin.users.level')">客戶級別管理</Link></li>
        </ul>
      </ul>
      <ul v-if="$page.props.current_admin.level >= 0">
        <li class="title">
          <Link :href="route('admin.orders') + '?type=new-coming'"
            >訂單管理</Link
          >
        </li>
      </ul>
      <ul v-if="$page.props.current_admin.level >= 0">
        <li class="title">
          <Link :href="route('admin.delivery')">出貨管理</Link>
        </li>
      </ul>
      <ul v-if="$page.props.current_admin.level >= 10">
        <li class="title">商品分類管理</li>
        <ul>
          <li><Link :href="route('admin.category')">分類管理</Link></li>
          <li><Link :href="route('admin.merchandise')">商品管理</Link></li>
          <li><Link :href="route('admin.add_on')">加購商品</Link></li>
          <li><Link :href="route('admin.pack')">組合包</Link></li>
        </ul>
      </ul>
      <ul v-if="$page.props.current_admin.level >= 10">
        <li class="title">行銷管理</li>
        <ul>
          <!-- <li><Link :href="route('admin.merchandise')">分潤/購物金</Link></li> -->
          <!-- <li><Link :href="route('admin.category')">優惠活動</Link></li> -->
          <li><Link :href="route('admin.free_shipping')">免運費</Link></li>
          <li><Link :href="route('admin.promotion')">促銷</Link></li>
        </ul>
      </ul>
      <ul v-if="$page.props.current_admin.level >= 10">
        <li class="title">頁面管理</li>
        <ul>
          <li><Link :href="route('admin.homepage')">首頁設定</Link></li>
          <li><Link :href="route('admin.ad')">廣告橫幅設定</Link></li>
          <li><Link :href="route('admin.pc')">商品列表設定</Link></li>
        </ul>
      </ul>
      <ul>
        <!-- 保留密碼管理功能 v-if="$page.props.current_admin.level >= 30" --->
        <li class="title">後台管理</li>
        <ul>
          <li><Link :href="route('admin.admins')">後台帳號管理</Link></li>
        </ul>
      </ul>
    </nav>
    <div class="flex-grow">
      <div class="my-3 text-right"></div>
      <hr class="text-fh-gray-light" />
      <div class="m-6">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";

export default {
  components: { Toast, ConfirmDialog },
  mounted() {
    Inertia.on("success", (event) => {
      if (this.$page.props.flash.success) {
        this.$toast.add({
          severity: "success",
          summary: this.$page.props.flash.success.summary,
          detail: this.$page.props.flash.success.detail,
          life: 3000,
        });
      }

      if (this.$page.props.flash.info) {
        this.$toast.add({
          severity: "info",
          summary: this.$page.props.flash.info.summary,
          detail: this.$page.props.flash.info.detail,
          life: 5000,
        });
      }

      if (this.$page.props.flash.warning) {
        this.$toast.add({
          severity: "warn",
          summary: this.$page.props.flash.warning.summary,
          detail: this.$page.props.flash.warning.detail,
          life: 10000,
        });
      }

      if (this.$page.props.flash.error) {
        this.$toast.add({
          severity: "error",
          summary: this.$page.props.flash.error.summary,
          detail: this.$page.props.flash.error.detail,
          life: 10000,
        });
      }
    });
  },
};
</script>


<style lang="postcss">
ul {
  @apply my-3 ml-5 text-white;
}

ul li {
  @apply my-2;
}

li.title {
  @apply text-xl;
}
</style>